import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import BatchScheduleCard from './Components/BatchScheduleCard';
import { batchClassSchedule } from '../../../../actions/batchClassActions';
import { useDispatch, useSelector } from 'react-redux';
import { getTodaysDate } from '../../../../api/dateFormat';
import { get, groupBy, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import NoData from '../../../../components/NoData/index.js';
import PageHeading from '../../../../components/PageHeading';

export default function BatchSchedule() {
  // const [selectedDate, setSelectedDate] = useState('');
  // const [dateArray, setDateArr] = useState([]);
  // const [lectureArray, setLectureArray] = useState([]);
  const [fullLectureArr, setFullLectureArr] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const dispatch = useDispatch();
  const jwtToken = useSelector(state =>
    get(state, 'loginReducer.data.jwt', '')
  );

  const batchClassData = useSelector(state =>
    get(state, 'batchClassReducer.data', {})
  );

  const errorMessage = useSelector(state =>
    get(state, 'batchClassReducer.errorMessage', '')
  );

  useEffect(() => {
    setIsFetching(true);
    batchClassSchedule(jwtToken, dispatch).then(() => setIsFetching(false));
  }, []);

  useEffect(() => {
    if (batchClassData && batchClassData.length > 0) {
      setTimeLineData();
    }
  }, [batchClassData]);

  const prepareArrForGivenDate = (obj, classTimeObj) => {
    let arr = [];
    if (obj && Object.keys(obj).length > 0) {
      for (let i = 0; i < Object.keys(obj).length; i++) {
        let lect_key = Object.keys(obj)[i] + '';
        if (obj[lect_key] && lect_key.includes('Lec_')) {
          arr.push({
            time: classTimeObj[lect_key],
            title: obj[lect_key],
            ClassDate: obj.ClassDate,
            ClassDay: obj.ClassDay,
            description: ''
          });
        }
      }
    }
    return arr;
  };

  const parseMonth = date => {
    if (date) {
      let strlength = date.length;
      return date.substring(strlength - 3, strlength);
    } else {
      return '';
    }
  };

  const parseDate = str => {
    return str.substring(0, 2);
  };

  const parseWeek = str => {
    return str.substring(0, 3);
  };

  const checkIfTodayDateLies = dateStr => {
    let today = new Date();
    if (dateStr == getTodaysDate(today)) {
      return true;
    }
    return false;
  };

  const setTimeLineData = () => {
    let lectureArr = [];
    let dateArr = [];
    let fullLecArr = [];
    batchClassData.map(item => {
      if (
        item.classDetail &&
        item.classTime &&
        item.classDetail.length > 0 &&
        Object.keys(item.classTime).length > 0
      ) {
        item.classDetail.map(obj => {
          if (checkIfTodayDateLies(obj.ClassDate)) {
            // setSelectedDate(obj.ClassDate);
            lectureArr = prepareArrForGivenDate(obj, item.classTime);
          }
          dateArr.push({ date: obj.ClassDate, day: obj.ClassDay });
          fullLecArr.push(...prepareArrForGivenDate(obj, item.classTime));
        });
      }
    });

    if (lectureArr.length == 0) {
      let classDetailObj = batchClassData[0].classDetail;
      let classTimeObj = batchClassData[0].classTime;
      if (classDetailObj && classDetailObj.length > 0)
        // setSelectedDate(classDetailObj[0].ClassDate);
        lectureArr = prepareArrForGivenDate(classDetailObj[0], classTimeObj);
    }
    setFullLectureArr(fullLecArr);
    // setLectureArray(lectureArr);
    // setDateArr(dateArr);
  };

  const populateData = groupBy(fullLectureArr, 'ClassDate');

  const createGrid = () => {
    let gridArr = [];
    const whenFetching = [1, 1, 1, 1];
    let dataKeys = isFetching ? whenFetching : Object.keys(populateData);
    let data = [];
    for (let i = 1; i <= dataKeys.length; i++) {
      data = isFetching ? '' : get(populateData, dataKeys[i - 1], []);
      gridArr.push(
        <Grid item xs={12} className="batch-card" key={'key' + i}>
          <BatchScheduleCard
            data={data}
            month={isFetching ? '' : parseMonth(dataKeys[i - 1])}
            date={isFetching ? '' : parseDate(dataKeys[i - 1])}
            day={isFetching ? '' : parseWeek(data[0].ClassDay)}
            isFetching={isFetching}
          />
        </Grid>
      );
    }
    return gridArr;
  };
  return (
    <React.Fragment>
      <PageHeading titlePrimary="Batch Class" titleSecondary="Schedule" />
      {isFetching || (batchClassData && batchClassData.length != 0) ? (
        <Grid container spacing={2} className="pt-50">
          {createGrid()}
        </Grid>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </React.Fragment>
  );
}

BatchSchedule.propTypes = {
  data: PropTypes.array,
  month: PropTypes.string,
  date: PropTypes.string,
  day: PropTypes.string
};
